import "./SushiGrid.scss";
import Asset from "../../../assets/alexfish_asset.webp";
import { useTranslation } from "react-i18next";

export default function SushiGrid() {
  const { t } = useTranslation();
  return (
    <div className="sushi-grid">
      <div className="element">
        <img
          src="https://alexfish-static.s3.eu-north-1.amazonaws.com/grid1-new.png"
          alt="Суши"
        />
      </div>
      <div className="element">
        <div className="text">
          <div className="icon">
            <img src="https://alexfish-static.s3.eu-north-1.amazonaws.com/vespa_icon.svg"></img>
          </div>
          <p>
            <span>Поръчай прясна и вкусна храна в няколко лесни стъпки:</span>
            <br /> <br />
            1.Сложете желаните продукти в кошницата.
            <br />
            2.Попълнете своите данни за контакт и адрес за доставка.
            <br />
            3.Изберете начин на доставка и плащане.
            <br />
            4.Потвърдете поръчката.
            <br /> <br />
            Ще получите съобщение, когато поръчката Ви е приета и пътува към
            Вас.
            <br /> Минималната стойност за доставка е{" "}
            {Number(30 / 1.95583).toFixed(2)}€/30 лв. <br />
            Цена на доставка: {Number(6 / 1.95583).toFixed(2)}€/6 лв. <br />
            Безплатна доставка за поръчки над{" "}
            {Number(100 / 1.95583).toFixed(2)}€/100 лв.
          </p>
        </div>
      </div>
      <div className="element">
        <img
          src="https://alexfish-static.s3.eu-north-1.amazonaws.com/grid2-new.png"
          alt="Суши"
        />
      </div>
      <div className="element">
        <img src={Asset} alt="Суши" />
      </div>
      <div className="element">
        <img
          src="https://alexfish-static.s3.eu-north-1.amazonaws.com/grid3-new.png"
          alt="Суши"
        />
      </div>
      <div className="element">
        <img
          src="https://alexfish-static.s3.eu-north-1.amazonaws.com/grid6.png"
          alt="Суши"
        />
      </div>
    </div>
  );
}
